<template>
	<div>
		<div class="mb-10" v-if="isWaitTask">
			<Tip type="warning" content="上次设置产生的数据还在订正中，订正完成后可再次修改设置。" />
		</div>
		<div class="illustrate radius-4">
			<div class="flex-row flex-align-center pos-rela">
				<i class="line"></i>
				<span class="mr-8 yx-color-text-primary font-h4-regular">样品订单是否展示【待审核】状态</span>
				<el-switch
					:disabled="disableSwitch"
					:value="sampleAudit"
					inactive-color="#E2E3E8"
					:active-value="activeValue"
					:inactive-value="inactiveValue"
					@change="confirm"
				>
				</el-switch>
			</div>
			<div class="mt-16 yx-color-text-regular font-h6-regular">
				<p class="mt-12">1、设置项开启前历史订单默认审核通过，设置项开启后创建的样品订单需手动审核； </p>
				<p class="mt-6">2、设置项从开启到关闭，则所有待审核样品订单将自动审核通过；</p>
			</div>
		</div>
	</div>
</template>

<script>
import { getAuditConf, setAuditConf } from '@/api/sampleOrder';
import { AUDIT_STATUS_OPEN, AUDIT_STATUS_CLOSE } from '@/utils/dataMap';
export default {
	components: {  },
	data() {
		return {
			sampleAudit: AUDIT_STATUS_CLOSE, // 开关状态
			activeValue: AUDIT_STATUS_OPEN,
			inactiveValue: AUDIT_STATUS_CLOSE,
			isWaitTask: false, // 是否有待订正任务
			disableSwitch: false, // 是否禁用开关
		};
	},
	created() {
		this.getAudit();
	},
	methods: {
		async getAudit() {
			try {
				const { sampleAudit = AUDIT_STATUS_CLOSE, isWaitTask = false } = await getAuditConf({});
				this.isWaitTask = isWaitTask;
				this.disableSwitch = isWaitTask;
				//sampleAudit 1开启 2关闭
				this.sampleAudit = sampleAudit;
			} catch (error) {
				console.log(error);
			}
		},
		async confirm() {
			this.disableSwitch = true;
			// 开关更改为相反的状态
			const params = {
				sampleAudit: this.sampleAudit === AUDIT_STATUS_OPEN ? AUDIT_STATUS_CLOSE : AUDIT_STATUS_OPEN,
			};
			try {
				await setAuditConf(params);
				this.$message.success('操作成功！');
				this.getAudit();
			} catch (error) {
				console.log(error);
			} finally {
				this.disableSwitch = false;
			}
		},
	},
};
</script>
<style lang="less" scoped>
.illustrate {
	background-color: @background-color-base;
	padding: 22px 0 16px 27px;
	.line {
		position: absolute;
		width: 4px;
		height: 16px;
		border-radius: 2px;
		background: @color-primary;
		left: -27px;
		top: 4px;
	}
}
</style>
